"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardExportDialog = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useGenerateDashboardReportPDF_1 = __importDefault(require("@opsbase/react-gql-hooks/dashboard/useGenerateDashboardReportPDF"));
const ConfirmDialog_1 = __importDefault(require("@opsbase/web-dialogs/ConfirmDialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const useTaskWatcherActions_1 = __importDefault(require("@opsbase/web-taskwatcher/useTaskWatcherActions"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function DashboardExportDialog() {
    const self = (0, useSelf_1.default)();
    const generateDashboardReportPDF = (0, useGenerateDashboardReportPDF_1.default)();
    const { goBack } = (0, useNav_1.default)();
    const { watchTasks } = (0, useTaskWatcherActions_1.default)();
    const handleConfirm = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const task = yield generateDashboardReportPDF({ email: self.email });
        watchTasks([task]);
        goBack();
    }), [generateDashboardReportPDF, goBack, self.email, watchTasks]);
    return (react_1.default.createElement(ConfirmDialog_1.default, { size: DialogSize_1.default.X400_Y250, onConfirm: handleConfirm, disableGoBackOnConfirm: true },
        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('produce-print-friendly-dashboard'))));
}
exports.DashboardExportDialog = DashboardExportDialog;
exports.default = DashboardExportDialog;
